// Number
const mathToDecimals = (
  value: number,
  decimals: number,
  mathFunction: (value: number) => number,
) => {
  const multiplier = Math.pow(10, decimals);
  return mathFunction(value * multiplier) / multiplier;
};

export const mathRoundToDecimals = (value: number, decimals: number) => {
  return mathToDecimals(value, decimals, Math.round);
};

export const mathFloorToDecimals = (value: number, decimals: number) => {
  return mathToDecimals(value, decimals, Math.floor);
};

export const getSum = (...values: number[]): number => {
  return values.reduce((total, value) => total + value, 0);
};

export const getSumToDecimals =
  (decimals: number) =>
  (...values: number[]): number => {
    const multiplier = Math.pow(10, decimals);
    const roundedValues = values.map((v) => Math.round(v * multiplier));

    return getSum(...roundedValues) / multiplier;
  };

export const getNumberOrUndefined = (
  value: number | string | undefined,
): number | undefined => {
  switch (typeof value) {
    case 'number':
      return value;
    case 'string': {
      const parsed = parseInt(value);

      return !isNaN(parsed) ? parsed : undefined;
    }
    case 'undefined':
    default:
      return undefined;
  }
};

export const getNumber = (value: number | string | undefined): number =>
  getNumberOrUndefined(value) || 0;

export const addToTotal = (total: number, value?: number | string) => {
  return total + getNumber(value);
};

export const getLargerNumber = (value1: number, value2: number) =>
  value1 > value2 ? value1 : value2;

// Number Regex
export const regex_IsNumber = new RegExp(`^\\d+(\\.\\d+)?$`, 'g');

export const getRegex_IsNumberToDecimals = (decimals: number) =>
  new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`, 'g');
